import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// Sign-in with the platform's Keycloak realm: authorization code + PKCE, a public client, tokens
// kept in sessionStorage (per tab; Keycloak's own session makes a new tab sign in without a
// prompt), renewed with the refresh token before they expire. Everything is on the same origin as
// the app (the gateway serves /auth), so nothing needs configuring per deployment.

export const AUTHORITY = `${location.origin}/auth/realms/smbsuite`;
export const CLIENT_ID = 'smbsuite-web';
export const CALLBACK_PATH = '/auth-callback';

export const userManager = new UserManager({
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: `${location.origin}${CALLBACK_PATH}`,
  post_logout_redirect_uri: `${location.origin}/`,
  response_type: 'code',
  scope: 'openid email profile',
  automaticSilentRenew: true,
  monitorSession: false,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

/** A valid access token, renewed first if it is about to expire; null when signed out. */
export async function accessToken(): Promise<string | null> {
  let user = await userManager.getUser();
  if (user && (user.expired || (user.expires_in ?? 0) < 30)) {
    user = await userManager.signinSilent().catch(() => null);
  }
  return user && !user.expired ? user.access_token : null;
}
